export const electric = {
  meta: {
    name: 'Electric'
  },
  layout: {
    content: {
      border: {
        left: '0'
      },
      boxShadow: '0 0 4px rgba(0, 0, 0, .1)'
    }
  },
  sidebar: {
    background: {
      color: '#1a5679'
    },
    box: {
      shadow: 'inset 0 -15px 0 0 #134e6f'
    },
    divider: {
      color: '#4a7a98'
    },
    header: {
      border: {
        bottom: '1px solid var(--sidebar-divider-color)'
      },
      height: '110px',

      badge: {
        backgroundColor: '#4a7a98',
        color: 'var(--color-white)'
      }
    },

    section: {
      heading: {
        color: {
          _: '#87cddf',
          hover: '#a4d8eb',
          active: 'var(--color-white)'
        },
        icon: {
          background: {
            color: {
              active: '#feeA61'
            }
          },
          color: {
            _: '#87cddf',
            active: '#4f4c4c'
          }
        }
      },
      items: {
        border: {
          left: '2px solid #feeA61'
        },
        active: {
          item: {
            color: '#87cddf'
          }
        }
      },
      item: {
        backgroundColor: {
          active: '#154b6a',
          hover: 'rgba(255, 255, 255, .03)'
        },
        color: {
          _: '#a4d8eb',
          hover: '#c1e4f3',
          active: 'var(--color-white)'
        }
      }
    },
    user: {
      background: {
        color: '#134e6f'
      },
      name: {
        color: '#87cddf'
      },
      company: {
        color: '#fff'
      },
      trigger: {
        backgroundColor: '#4a7a98',
        color: 'var(--color-white)'
      }
    }
  }
};
